declare global {
  interface Window {
    dataLayer: any[]
  }
}

export const gtmDataPush = (category: string, id: string, eventUrl?: string) => {
  if (!window.dataLayer) {
    return
  }
  window.dataLayer.push({
    event: 'userData',
    category,
    id,
    eventUrl,
  })
}

export const gtmCalculatorDataPush = (calculatorId: string, calculatorResultData: any) => {
  if (!window.dataLayer) {
    return
  }
  window.dataLayer.push({
    event: 'userData',
    category: 'calculator-results',
    id: calculatorId,
    calculatorResultData,
  })
}
